import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildUpdateMutations } from '@/store/extensions/update';

export default {
  ...buildFetchMutations(['fetchVersions', 'fetchSingleVersion']),
  ...buildUpdateMutations(['revert']),

  revertVersionPending: (state) => {
    Vue.set(state, 'reverting', true);
  },

  revertVersionSuccess: (state) => {
    Vue.set(state, 'reverting', false);
  },

  revertVersionError: (state) => {
    Vue.set(state, 'reverting', false);
  },

  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  openDiffModal: (state, payload = null) => {
    Vue.set(state, 'diffModalOpened', true);
    Vue.set(state, 'diffModalAdditionalContext', payload);
  },

  closeDiffModal: (state) => {
    Vue.set(state, 'diffModalOpened', false);
    Vue.set(state, 'diffModalAdditionalContext', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/version/mutations.js